<template>
  <v-select
    class="font-weight-medium"
    title="Any"
    v-model="selectedData"
    :items="props.propsData"
    density="compact"
    variant="outlined"
    item-title="name"
    :label="props.boxName"
    item-value="id"
    @update:modelValue="clickHandler"
    persistent-hint
    multiple
  >
    <!-- <template v-slot:selection="{ item, index }">
        <v-chip v-if="index < 2">
          <span>{{ item.title }}</span>
        </v-chip></template
      > -->
    <template v-slot:prepend-item>
      <div v-if="props.propsData !== undefined && props.propsData.length !== 0">
        <v-list-item title="Select All" @click="toggle">
          <template v-slot:prepend>
            <v-checkbox-btn
              :color="'indigo-darken-4'"
              :indeterminate="SomeItems && !AllItems"
              :model-value="selectAllFlag"
            ></v-checkbox-btn>
          </template>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </div>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index < 2">
        <span>{{ item.title }}</span>
      </v-chip>
      <span v-if="index === 2" class="text-grey text-caption align-self-center">
        (+{{ selectedData.length - 2 }} others)
      </span>
    </template>
  </v-select>
</template>
<script setup>
import { defineProps, ref, watchEffect } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  propsData: {
    type: Array,
    default: () => [{ sectorID: 0, sectorName: "Any" }],
  },
  boxName: {
    type: String,
  },
});
const disSelect = ref();
const view = ref([]);
const selectedID = ref();
const offerOrigin = ref(store.getters["Sector/getOfferOrigin"]);
const selectedData = ref([]);
// const selectedID = ref();
const previousSelectedStructures = ref([]);
const selectAllFlag = ref(false);

watchEffect(() => {
  selectedData.value = store.getters["Sector/getCategorySelectedGetters"];

  // let dropdown = store.getters["Sector/getselectedDataGetters"];
  // if (Object.keys(dropdown).length > 0) {
  //   console.log(dropdown, "dropdown");
  //   if (props.boxName === "Category") {
  //     selectedData.value = dropdown["categoryID"][0];
  //   }
  // }
  // selectAllFlag.value = store.getters["Sector/getSelectAllFlagGetters"];
  // console.log(props.propsData, "props");
  // console.log(selectedData.value, "sel");
  // console.log(12, store.getters["Sector/getcategoriesParentsGetters"]);
  // let lastSearchCategories =
  //   store.getters["Sector/getcategoriesParentsGetters"];
  // if (
  //   lastSearchCategories !== undefined &&
  //   Object.keys(lastSearchCategories).length > 0
  // ) {
  //   for (let i of lastSearchCategories["cat"]) {
  //     // console.log(typeof i, "i", view.value);
  //     let status = view.value.indexOf(i);
  //     // console.log(status, "st");
  //     if (!status) {
  //       view.value.push(i);
  //     }
  //   }
  // }
  if (
    props.propsData !== undefined &&
    props.propsData !== null &&
    selectedData.value !== undefined &&
    selectedData.value !== null
  ) {
    //let flag = store.getters["Sector/getLastSearchActivatedGetters"];
    if (
      Object.keys(props.propsData).length ===
      Object.keys(selectedData.value).length
    ) {
      selectAllFlag.value = true;
      // toggle();
      // if (flag) {
      // let temp = [];
      selectedData.value.forEach((t) => {
        view.value.push(t.id);
      });
      // }
      // console.log(temp, "temp");
    } else if (
      Object.keys(selectedData.value).length &&
      Object.keys(props.propsData).length > 0
    ) {
      // let temp = [];
      // selectedData.value.forEach((t) => {
      //   temp.push(t.id);
      // });
      // clickHandler(temp);
      // console.log([t.id], "t", typeof t.id);
      // let temp = [];
      selectedData.value.forEach((t) => {
        view.value.push(t.id);
      });
      // console.log(temp, "temp");
      selectAllFlag.value = false;
    }
    // console.log(selectedData.value, "sel len");
    // console.log(props.propsData.length, "props len");
  }
});

function offerOriginFn(id, dis) {
  // console.log(id, dis);
  let obj = store.getters["Rawdata/getofferOriginChanged"];
  if (dis === "add") {
    for (let i = 0; i < obj.length; i++) {
      let sectors = obj[i].oo_sectorID;
      if (sectors.includes(id)) {
        // Check for duplicates before pushing
        let found = offerOrigin.value.some(
          (item) => item.oo_id === obj[i].oo_id
        );
        if (!found) {
          offerOrigin.value.push(obj[i]);
        }
      }
    }
  } else if (dis === "delete") {
    // If 'delete' parameter is passed, remove the object from the offerOrigin.value array
    for (let i = 0; i < offerOrigin.value.length; i++) {
      let sectors = offerOrigin.value[i].oo_sectorID;
      if (sectors.includes(id)) {
        // Use splice to remove the item from array by index
        offerOrigin.value.splice(i, 1);
        i--; // Decrement index after removal to avoid skipping elements
      }
    }
  } else if (dis === "all") {
    offerOrigin.value = [];
  }
  // console.log(offerOrigin.value, "offerOrigin.value");
  store.dispatch("Sector/setOfferOrigin", offerOrigin.value);
}
function clickHandler(e) {
  // console.log(e, "aae", typeof e);
  // console.log(view.value, "v");
  store.dispatch("Sector/setLastSearchActivated", false);
  // if (typeof e !== Object) {
  //   let array = e.toString().split(" ");
  //   // array.map((t) => Number(t));
  //   console.log(array, "arr");
  //   e = array;
  // }
  // console.log(e, "aae", typeof e);
  // console.log(props.boxName, "aaaa");
  let catPayload = store.getters["Sector/getcategoryPayload"];
  const searchCry = {
    val: e,
    column: props.boxName,
    entirs: props.propsData,
  };
  store.dispatch("Rawdata/setSearchCritertia", searchCry);
  // let subCatData = store.getters["Sector/getSubCategoryGetters"];
  store.dispatch("Sector/setcategorySelectedAct", e);
  let catData = store.getters["Sector/getcategorySector"];
  let catSelectedRec = [];
  // console.log(catData, "catData");
  catData.forEach((i) => {
    let found = e.includes(i.id);
    if (found) {
      catSelectedRec.push(i);
    }
  });
  // console.log(catSelectedRec, "catSelect");
  store.dispatch("Sector/setcategorySelectedAct", catSelectedRec);
  Object.keys(catPayload).find((key) => {
    if (key === "cat_") {
      e.forEach((i) => {
        // const index = catPayload[key].indexOf(i.sectorID);
        // console.log(i.sectorID, "i");
        // if (index === -1) {
        if (!catPayload[key].includes(i)) {
          store.dispatch("Sector/setcategoryPayloadAct", i);
          // state.categoryPayload[key].push(i.sectorID);
          // }
        }
      });
    }
  });
  // console.log(props.boxName);
  if (props.boxName == "Category") {
    // e.forEach((i) => {
    //   store.dispatch("Sector/setcategoryPayloadAct", i.sectorID);
    // });
    // console.log(e, "term");
    if (e.length === 0) {
      store.dispatch("Sector/setTermLength", false);
    } else {
      for (let i = 0; i < e.length; i++) {
        // store.dispatch("Sector/setcategoryPayloadAct", e[i].sectorID);
        if (e[i] === 13) {
          store.dispatch("Sector/setTermLength", true);
          break;
        } else {
          store.dispatch("Sector/setTermLength", false);
        }
      }
    }
  }
  let ridersOriginal = store.getters["Rawdata/getDropdownDataAPI"].riders;
  // console.log(ridersOriginal, "ridersOriginal");
  let ridersDataNames = [];
  // console.log("3data", ridersOriginal, e);
  if (e.length > 0) {
    // console.log(11, e[0].sectorID);
    for (let i = 0; i < ridersOriginal.length; i++) {
      let secidArray = ridersOriginal[i].riders_sectorID
        .split(",")
        .map((id) => id.trim());
      // console.log(secidArray, "secidArray");
      let status = secidArray.includes(e.toString());
      // console.log(status, "status");
      if (status) {
        ridersDataNames.push(ridersOriginal[i]);
      }
    }
  }
  // console.log("ridersDataNames", ridersDataNames);
  store.dispatch("Sector/setSectorIdsRiders", ridersDataNames);

  let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
  let issueDataNames = [];
  if (e.length > 0) {
    // console.log(11, e[0].sectorID);
    for (let i = 0; i < issuesOriginal.length; i++) {
      let secidArray = issuesOriginal[i].sector_id
        .split(",")
        .map((id) => id.trim());
      let status = secidArray.includes(e.toString());
      if (status) {
        issueDataNames.push(issuesOriginal[i]);
      }
    }
  }
  // console.log(issueDataNames, "issueDataNames");
  store.dispatch("Sector/setIssueTypeData", issueDataNames);

  let checkboxSelected = JSON.parse(JSON.stringify(view.value));
  // console.log(checkboxSelected, "vuiew");
  // console.log(checkboxSelected.length, "len");
  // console.log(view.value, "view");
  disSelect.value = null;
  selectedID.value = null;
  if (e.length >= view.value.length) {
    if (e.length != 0 && e !== undefined) {
      for (let i of e) {
        // console.log("first i", i);
        let found = !JSON.parse(JSON.stringify(checkboxSelected)).includes(i);
        // view.value.push(i.id);
        // console.log(found, "firstfound");
        if (found) {
          selectedID.value = i;
        } else {
          selectedID.value = i;
        }
      }
      // if (selectedID.value === 14) {
      // this one will show further value in offer origin if 14 is selected
      offerOriginFn(selectedID.value, "add");
      // }

      view.value = e;
    }
  } else {
    if (view.value.length != 0 && view.value !== undefined) {
      for (let i of view.value) {
        // console.log("second i", i);
        let found = !JSON.parse(JSON.stringify(e)).includes(i);
        // console.log(found, "second found");
        if (found) {
          // console.log(i, "i");
          disSelect.value = i;
          // if (i == 14) {
          // this one will show further value in offer origin if 14 is selected
          offerOriginFn(i, "delete");
          // }
        }

        // view.value.push(i.id);
      }
      view.value = e;
    }
  }

  previousSelectedStructures.value = e;
  // console.log("count len", count);
  // console.log(e[count - 1].sectorID);
  // console.log("diselect len", disSelect.value.length);
  if (disSelect.value) {
    // console.log(disSelect.value[0].sectorID);
    categoryDisSelectionHandler(disSelect.value);
  } else {
    //the below function executes when user add option in the dropdown
    // switchSubCategoryFunctionCases(selectedID.value);
    let faceOriginal = store.getters["Rawdata/getDropdownDataAPI"].faceamount;
    store.dispatch("Sector/setSectorFaceAmtData", faceOriginal);
    sectorsFnHandler(selectedID.value, "Sector/setSubCategoryAction");
  }
}

function toggle() {
  if (selectAllFlag.value === false) {
    selectAllFlag.value = true;
  } else {
    selectAllFlag.value = false;
  }
  // console.log(selectAllFlag.value, "sel");
  // store.dispatch("Sector/setSelectAllFlagAction", selectAllFlag.value);
  // console.log(props.boxName);
  // console.log(selectAllFlag.value, "tog");
  // selectedData.value = props.propsData;
  // console.log(selectedData.value);
  // console.log(selectedData.value.length, props.propsData.length);
  // console.log(selectAllFlag.value);
  // console.log(props.propsData, props.boxName);
  disSelect.value = null;
  if (selectAllFlag.value) {
    selectedData.value = [];
    // console.log(props.propsData);
    selectedData.value = props.propsData;
    store.dispatch("Sector/setcategorySelectedAct", props.propsData);
    // console.log(1, selectedData.value);
    // if (props.boxName === "Category") {
    if (selectedData.value !== undefined) {
      selectedData.value.forEach((i) => {
        view.value.push(i.id);
        let catPayload = store.getters["Sector/getcategoryPayload"];
        offerOriginFn(i.id, "add");
        // console.log(i);
        // let subCatData = store.getters["Sector/getSubCategoryGetters"];
        // store.dispatch("Sector/setcategorySelectedAct", i);
        // console.log(catSelectedRec, "catSelect");
        Object.keys(catPayload).find((key) => {
          if (key === "cat_") {
            // const index = catPayload[key].indexOf(i.sectorID);
            // console.log(i.sectorID, "i");
            // if (index === -1) {
            if (!catPayload[key].includes(i.id)) {
              store.dispatch("Sector/setcategoryPayloadAct", i.id);
              // state.categoryPayload[key].push(i.sectorID);
              // }
            }
          }
        });
        // offerOrigin(i.id);
        sectorsFnHandler(i.id, "Sector/setSubCategoryAction");
      });
      // console.log(view.value, "view");
      const searchCry = {
        val: view.value,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      // }
      // else if (props.boxName === "Sub Category") {
      //   selectedData.value.forEach((i) => {
      //     switchSubCategoryFunctionCases(i);
      //   });
      // } else if (props.boxName === "Sub Sub Category") {
      //   selectedData.value.forEach((i) => {
      //     switchSubCategoryFunctionCases(i);
      //   });
      // }
    }
  } else {
    // console.log(selectedData.value);
    selectedData.value.forEach((i) => {
      categoryDisSelectionHandler(i.id);
      offerOriginFn(i.id, "delete");
    });
    selectedData.value = [];
    store.dispatch("Sector/setcategorySelectedAct", selectedData.value);
  }
}

function categoryDisSelectionHandler(disid) {
  // console.log(disid, "disid", typeof disid);
  store.dispatch("Sector/setunCheckcategoryPayloadAct", disid);
  let subCatData = store.getters["Sector/getSubCategoryGetters"]; //this one is updating real time data
  let subsubCatData = store.getters["Sector/getSubSubCategoryGetters"];
  let subCatSelectedData =
    store.getters["Sector/getSubCategorySelectedGetters"];
  let subsubCatSelectedData =
    store.getters["Sector/getsubSubCategorySelectedGetters"];
  // console.log(subCatData, "subCatData");
  //handling of sub categories
  // let subcount = 0;
  // for (const i in subCatData) {
  //   if (subCatData[i].subpid === disid) {
  //     subcount++; //adding up of number of records of the id which was unchecked
  //   }
  // }
  // console.log(subCatData, "subCatData");
  // offerOrigin(null, disid);
  // let lastSearchsubCatGetters = store.getters["Sector/getSubCategoryGetters"];
  // console.log(lastSearchsubCatGetters, "lastSearchsubCatGetters");
  //removing data from sub category dropdown
  let filteredSubCat = subCatData.filter((f) => f.subpid !== disid);
  store.dispatch("Sector/setSubCategoryAction", filteredSubCat); //updating in vuex
  //removing data from sub category selected data
  console.log(filteredSubCat, "filteredSubCat");
  let filteredSubCatselected = subCatSelectedData.filter(
    (f) => f.subpid !== disid
  );
  // console.log(filteredSubCat, "filteredSubCat");
  store.dispatch("Sector/setsubcategorySelectedAct", filteredSubCatselected);

  // console.log(filteredSubCatselected, "filteredSubCatselected");

  //removing data from sub sub category dropdown
  let filteredSubSubCat = subsubCatData.filter((f) => f.subpid !== disid);
  store.dispatch("Sector/setSubSubCategoryAction", filteredSubSubCat); //updating in vuex

  //removing data from sub sub category selected data
  let filteredSubsubCat = subsubCatSelectedData.filter(
    (f) => f.subpid !== disid
  );
  // console.log(filteredSubsubCat, "filteredSubsubCat");
  store.dispatch("Sector/setsubsubcategorySelectedAct", filteredSubsubCat);
  // console.log(filteredSubsubCat, "filteredSubsubCat");

  if (disid == 13) {
    store.dispatch("Sector/setSectorFaceAmtData", [{ fa_name: "Any" }]);
  }

  // issue type data
  let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
  for (let i = 0; i < issuesOriginal.length; i++) {
    let secidArray = issuesOriginal[i].sector_id
      .split(",")
      .map((id) => id.trim());
    let status = secidArray.includes(disid.toString());
    if (status) {
      issuesOriginal.slice(i, 1);
    }
  }
  if (disid == 13) {
    store.dispatch("Sector/setIssueTypeData", [{ IssueTypeName: "Any" }]);
  }
}

async function sectorsFnHandler(id, actionName) {
  // console.log(typeof id, actionName);
  let subcat = store.getters["Sector/getAllSubCategoryLocalGetters"];
  let showsubcatstore = store.getters["Sector/getSubCategoryGetters"];
  // let storeData = store.getters["Sector/getcategorySector"];
  // console.log(showsubcatstore, "showsubcatstore");
  // Create a Set to store unique values
  let catnameIsSelected = 0;
  let uniqueValues = new Set();
  // console.log(props.propsData, "pp");
  props.propsData.forEach((p) => {
    if (Number(p.id) === Number(id)) {
      catnameIsSelected = p.name;
    }
  });
  // console.log(catnameIsSelected, "catnameIsSelected");
  // console.log(subcat, "subcat");
  // Filter unique values from 'cat' array based on the condition
  // eslint-disable-next-line no-unused-vars
  Object.entries(subcat).forEach(([key, value]) => {
    // console.log(value, "val");
    if (value.subpid === id) {
      uniqueValues.add(value);
    }
  });

  // Filter unique values from 'showcatstore' array
  // showsubcatstore.forEach((t) => {
  //   uniqueValues.add(t);
  // });
  // console.log(uniqueValues, "uniqe");
  // Convert the Set back to an array ('showcat') to match your original data structure
  let showcat = [...uniqueValues];
  // console.log(showcat, "showcat");
  showcat.forEach((p) => {
    let arrowFlag = p.name.includes(" >> ");
    if (!arrowFlag) {
      p.name = catnameIsSelected + " >> " + p.name;
    }
  });

  //MATCH showsubcatstore and showcat merge it if its unique
  let newsubcatid = [];
  for (let i = 0; i < showcat.length; i++) {
    newsubcatid.push(showcat[i].id);
  }
  for (let j = 0; j < showsubcatstore.length; j++) {
    if (!newsubcatid.includes(showsubcatstore[j].id)) {
      showcat.push(showsubcatstore[j]);
    }
  }
  store.dispatch(actionName, showcat);
}
</script>
<style scoped>
* {
  font-size: 12px;
}
</style>
